module.exports = __webpack_public_path__ + "fonts/DM_Sans-300-latin-ext6.49935c4.woff2";